/**
 * Shared identifiers for the injected structured-output MCP server.
 * Imported by codex-agent.ts (server config), codex-client.ts (tool-call
 * matching), and structured-output-mcp-server.ts (tool registration) so the
 * three stay in sync.
 */

export const STRUCTURED_OUTPUT_MCP_NAME = "posthog_output";
export const STRUCTURED_OUTPUT_TOOL_NAME = "create_output";
